import Vfds from "../classes/Vfd"
import { Position } from 'reactflow';

export const vfds = [
  /*new Vfds({
    alias:"apartarrayos", 
    svgSrc: "/symbol-assets/Apartarrayos.svg", 
    label: "Apartarrayos"
  }),*/
  new Vfds({
    alias:"Línea Aérea A", 
    svgSrc: "/symbol-assets/LineaAerea.svg", 
    label: "Línea Aérea"
  }),
  new Vfds({
    alias:"Línea Aérea B", 
    svgSrc: "/symbol-assets/LineaAereaB.svg", 
    label: "Línea Aérea B"
  }),
  new Vfds({
    alias:"switchdetransferencia", 
    svgSrc: "/assets/editor-symbols/SwitchDeTransferencia.svg", 
    label: "Switch de transferencia",
    handles: [
      {
        id: "3e7701ed",
        type: "target",
        position: Position.Top,
        gridAlign: { count: 2, index: 0 }
      },
      {
        id: "8520",
        type: "target",
        position: Position.Top,
        gridAlign: { count: 2, index: 1 }
      },
      {
        id: "46c1",
        type: "source",
        position: Position.Bottom
      }                  
    ]
  }),
];
